import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./kpiView.module.scss";

const SEVERITY_LEVELS = [
  { key: "74", className: styles.anomalySeverityCritical },
  { key: "75", className: styles.anomalySeverityWarning },
  { key: "76", className: styles.anomalySeverityInfo },
];

export default function KpiAnomalyAlertInfo({ theme = "dark" }) {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.anomalyInfo} ${
        theme === "dark" ? styles.anomalyInfoDark : ""
      }`}
    >
      <section className={styles.anomalyInfoSection}>
        <h4>{t("team_kpi_view.44")}</h4>
        <p>{t("team_kpi_view.45")}</p>
      </section>
      <section className={styles.anomalyInfoSection}>
        <h4>{t("team_kpi_view.73")}</h4>
        <ul className={styles.anomalySeverityList}>
          {SEVERITY_LEVELS.map(({ key, className }) => (
            <li key={key} className={className}>
              {t(`team_kpi_view.${key}`)}
            </li>
          ))}
        </ul>
      </section>
      <section className={styles.anomalyInfoSection}>
        <h4>{t("team_kpi_view.58")}</h4>
        <ul className={styles.anomalyInfoList}>
          <li>{t("team_kpi_view.59")}</li>
          <li>{t("team_kpi_view.60")}</li>
          <li>{t("team_kpi_view.61")}</li>
          <li>{t("team_kpi_view.62")}</li>
        </ul>
      </section>
      <section className={styles.anomalyInfoSection}>
        <h4>{t("team_kpi_view.46")}</h4>
        <p>{t("team_kpi_view.47")}</p>
      </section>
      <section className={styles.anomalyInfoSection}>
        <h4>{t("team_kpi_view.48")}</h4>
        <p>{t("team_kpi_view.49")}</p>
        <p className={styles.anomalyInfoNote}>{t("team_kpi_view.80")}</p>
      </section>
    </div>
  );
}
